/**
 * @file Custom prints related fragments.
 */

import gql from 'graphql-tag';

export const WebGalleryAlbumCustomPrintDetails = gql`
  fragment WebGalleryAlbumCustomPrintDetails on AlbumCustomPrint {
    id
    photos_no
    custom_print {
      id
      type
      name
      photos_no
      custom_print_caption_enabled
      user_notice
      account_address {
        id
      }
      preview_image {
        id
        url
      }
      background_image {
        id
        url
      }
      account {
        id
        logo_image {
          id
          url
        }
      }
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    shipping_price {
      value
      currency
    }
    album {
      id
      album_type
      album_subtype
    }
    shipping_enabled
    shipping_required
  }
`;
